export const findInfo = (arr, key) =>{
    const rezult = arr.find(elements =>{
        return elements.key === key
    })

    return rezult?.value || false;
}